import { TIME_INPUT_FORMAT } from 'transfix-ui'
import FORMATS from 'constants/datetime'
import { SETTINGS_TIME_FORMAT } from '../types'

const {
  militaryTimeFormat,
  militaryTimeFormatShort,
  militaryTimeFormatShort12H,
  stopAppointmentMilitaryFormat,
  stopAppointmentMilitaryFormatFull,
  stopAppointmentSameDayEndAtStandardFormat,
  stopAppointmentStandardFormat,
  stopAppointmentStandardFormatFull,
} = FORMATS

export interface ITimeFormats {
  sameDay: string
  stopAppointment: string
  stopAppointmentFull: string
  listStopAppointment: string
  stopTimeInput: TIME_INPUT_FORMAT
}

// Collection of military formats, grouped
export const militaryFormats: ITimeFormats = {
  sameDay: militaryTimeFormat,
  stopAppointment: stopAppointmentMilitaryFormat,
  stopAppointmentFull: stopAppointmentMilitaryFormatFull,
  listStopAppointment: militaryTimeFormatShort,
  stopTimeInput: TIME_INPUT_FORMAT.MILITARY,
}

// Collection of standard formats, grouped
export const standardFormats: ITimeFormats = {
  sameDay: stopAppointmentSameDayEndAtStandardFormat,
  stopAppointment: stopAppointmentStandardFormat,
  stopAppointmentFull: stopAppointmentStandardFormatFull,
  listStopAppointment: militaryTimeFormatShort12H,
  stopTimeInput: TIME_INPUT_FORMAT.MILITARY_SHORT,
}

export const getTimeFormats = (timeFormat: SETTINGS_TIME_FORMAT): ITimeFormats => {
  const formats: Record<SETTINGS_TIME_FORMAT, ITimeFormats> = {
    [SETTINGS_TIME_FORMAT.STANDARD]: standardFormats,
    [SETTINGS_TIME_FORMAT.MILITARY]: militaryFormats,
  }

  return formats[timeFormat]
}
